<template>
  <div class="mt-4">
    <h4>{{ $t("message.yourDetails") }}</h4>
    <div class="form-row">
      <!--      <div class="form-group col-md-6">-->
      <!--        <label v-if="!isRolldStore()" class="required" for="First Name">{{-->
      <!--          $t("message.firstName")-->
      <!--        }}</label>-->
      <!--        <label-->
      <!--          v-if="isRolldStore()"-->
      <!--          :class="editModel.FirstName ? 'd-none' : 'required rolld'"-->
      <!--          for="firstName"-->
      <!--        ></label>-->
      <!--        <input-->
      <!--          v-validate="'required|min:2'"-->
      <!--          id="firstName"-->
      <!--          :placeholder="isRolldStore() ? $t('message.firstName') : ''"-->
      <!--          v-model="editModel.FirstName"-->
      <!--          @change="syncFirstName(editModel.FirstName)"-->
      <!--          name="firstName"-->
      <!--          type="text"-->
      <!--          class="form-control"-->
      <!--        />-->
      <!--        <div class="invalid-feedback">-->
      <!--          {{ OOErrors.first("firstName") | inputNameLocale("firstName") }}-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="form-group col-md-6">-->
      <!--        <label v-if="!isRolldStore()" class="required" for="Last Name">{{-->
      <!--          $t("message.lastName")-->
      <!--        }}</label>-->
      <!--        <label-->
      <!--          v-if="isRolldStore()"-->
      <!--          :class="editModel.LastName ? 'd-none' : 'required rolld'"-->
      <!--          for="lastName"-->
      <!--        ></label>-->
      <!--        <input-->
      <!--          v-validate="'required|min:2'"-->
      <!--          id="lastName"-->
      <!--          :placeholder="isRolldStore() ? $t('message.lastName') : ''"-->
      <!--          v-model="editModel.LastName"-->
      <!--          name="lastName"-->
      <!--          type="text"-->
      <!--          class="form-control"-->
      <!--        />-->
      <!--        <div class="invalid-feedback">-->
      <!--          {{ OOErrors.first("lastName") | inputNameLocale("lastName") }}-->
      <!--        </div>-->
      <!--      </div>-->

      <!--   name field new workflow   -->
      <div class="form-group col-md-6">
        <label v-if="!isRolldStore()" class="required" for="Name">{{
          $t("message.name")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.FirstName ? 'd-none' : 'required rolld'"
          for="Name"
        ></label>
        <input
          v-validate="'required|min:2'"
          id="Name"
          :placeholder="isRolldStore() && $t('message.firstName')"
          v-model="fullName"
          :disabled="disableNameField"
          name="name"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("name") | inputNameLocale("name") }}
        </div>
      </div>

      <div class="form-group col-md-6" v-if="displayMobileField">
        <label v-if="!isRolldStore()" class="required" for="phoneNumber">{{
          $t("message.mobile")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.Phone ? 'd-none' : 'required rolld'"
          for="phoneNumber"
        ></label>
        <input
          v-validate="{
            required: true,
            min: 8
          }"
          id="phoneNumber"
          :placeholder="isRolldStore() && $t('message.phoneNumber')"
          v-model="editModel.Phone"
          name="phoneNumber"
          :disabled="isMobileReadonly"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}
        </div>
      </div>
    </div>

    <div class="form-row" v-if="displayEmailField || createNewAccount">
      <div class="form-group col-md-12">
        <label v-if="!isRolldStore()" class="required" for="EmailAddress">{{
          $t("message.email")
        }}</label>
        <label
          v-if="isRolldStore()"
          :class="editModel.Email ? 'd-none' : 'required rolld'"
          for="email"
        ></label>
        <input
          @input="onEmailChange()"
          v-validate="'required|email'"
          id="EmailAddress"
          :placeholder="isRolldStore() && $t('message.email')"
          v-model="editModel.Email"
          :disabled="isEmailReadonly"
          name="email"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">
          {{ OOErrors.first("email") | inputNameLocale("email") }}
        </div>
      </div>

      <!--      <div class="form-group col-md-6">-->
      <!--        <label v-if="!isRolldStore()" class="required" for="phoneNumber">{{-->
      <!--          $t("message.phoneNumber")-->
      <!--        }}</label>-->
      <!--        <label-->
      <!--          v-if="isRolldStore()"-->
      <!--          :class="editModel.Phone ? 'd-none' : 'required rolld'"-->
      <!--          for="phoneNumber"-->
      <!--        ></label>-->
      <!--        <input-->
      <!--          v-validate="{-->
      <!--            required: true,-->
      <!--            min: 8,-->
      <!--            regex: this.getRegex(),-->
      <!--          }"-->
      <!--          id="phoneNumber"-->
      <!--          :placeholder="isRolldStore() ? $t('message.phoneNumber') : ''"-->
      <!--          v-model="editModel.Phone"-->
      <!--          name="phoneNumber"-->
      <!--          :disabled="isMobileReadonly"-->
      <!--          type="text"-->
      <!--          class="form-control"-->
      <!--        />-->
      <!--        <div class="invalid-feedback">-->
      <!--          {{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}-->
      <!--        </div>-->
      <!--      </div>-->
    </div>

    <!-- <div class="form-row" v-show="createNewAccount">
      <div class="form-group col-md-12">
        <div class="form-group ">
          <label for="password"
          >{{ $t("message.password") }}
            <span class="required-logo">*</span>
          </label>
          <input
              id="passwordId"
              v-model="editModel.Password"
              type="password"
              name="password"
              v-validate="'required|min:6'"
              class="form-control"
              ref="password"
              autocomplete="new-password"
          />
          <div class="invalid-feedback">
            {{ OOErrors.first("password") | inputNameLocale("password") }}
          </div>
        </div>
        <div class="form-group">
          <label for="Confirm Password">
            {{ $t("message.confirmPassword") }}
            <span class="required-logo">*</span>
          </label>
          <input
              id="ConfirmPasswordId"
              v-model="editModel.ConfirmPassword"
              type="password"
              name="confirmPassword"
              v-validate="'required|confirmed:password'"
              class="form-control"
          />
          <div class="invalid-feedback">
            {{
              OOErrors.first("confirmPassword")
                  | inputNameLocale("confirmPassword")
            }}
          </div>
        </div>

        <div v-if="!isRolldStore()" class="form-group">
          <label for="birth Date"
          >{{ $t("message.birthDate") }}
            <span class="required-logo">*</span>
          </label>
          <date-pick
              id="BirthDate"
              name="birthDate"
              v-model="editModel.BirthDate"
              :format="'DD/MM/YYYY'"
              :inputAttributes="{
                placeholder: 'DD/MM/YYYY',
                class: ['form-control', bdstatus],
              }"
              @input="isValidDate($event)"
              :parseDate="parseDate"
          ></date-pick>
          <span
              v-if="birthDatestatus != 0"
              class="invalid-feedback"
              style="display: block;"
          >{{
              birthDatestatus == 1
                  ? $t("message.birthDateRequire")
                  : "The Date of Birth should be DD/MM/YYYY format"
            }}</span
          >
          <div class="invalid-feedback">
            {{ OOErrors.first("birthDate") | inputNameLocale("birthDate") }}
          </div>
        </div>

      </div> -->

    <!--      <div class="form-group col-md-6">-->
    <!--        <label v-if="!isRolldStore()" class="required" for="phoneNumber">{{-->
    <!--          $t("message.phoneNumber")-->
    <!--        }}</label>-->
    <!--        <label-->
    <!--          v-if="isRolldStore()"-->
    <!--          :class="editModel.Phone ? 'd-none' : 'required rolld'"-->
    <!--          for="phoneNumber"-->
    <!--        ></label>-->
    <!--        <input-->
    <!--          v-validate="{-->
    <!--            required: true,-->
    <!--            min: 8,-->
    <!--            regex: this.getRegex(),-->
    <!--          }"-->
    <!--          id="phoneNumber"-->
    <!--          :placeholder="isRolldStore() ? $t('message.phoneNumber') : ''"-->
    <!--          v-model="editModel.Phone"-->
    <!--          name="phoneNumber"-->
    <!--          :disabled="isMobileReadonly"-->
    <!--          type="text"-->
    <!--          class="form-control"-->
    <!--        />-->
    <!--        <div class="invalid-feedback">-->
    <!--          {{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!-- </div> -->

    <div
      v-if="viewConfig.LogIn && this.isBranded() && !user && !forGift"
      class="form-row"
    >
      <div class="form-group col-md-12 mb-0">
        <div class="custom-control custom-checkbox col-md-12 ml-12">
          <input
            id="newAccount"
            type="checkbox"
            name="customCheckbox"
            :checked="createNewAccount"
            @change="check"
            class="custom-control-input"
            @input="(val) => $emit('save-user', val.target.checked)"
          />
          <label
            class="custom-control-label join-membership-text"
            for="newAccount"
          >
            {{ $t("message.joinMembershipToEarnStamps") }}
            <!--            <small class="light-text d-block">-->
            <!--              {{ $t("message.placingOrderAsGuest")}}-->
            <!--            </small>-->
          </label>
        </div>
      </div>
      <div class="form-group col-md-12">
        <div v-if="createNewAccount && isRegistered">
          {{ $t("message.alreadyAccountForEmail") }}
          <a
            href="#"
            class="text-primary"
            style="cursor: pointer"
            @click.prevent="setShowOverlay(true)"
            >{{ $t("message.login") }}</a
          >&nbsp;here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { userIsExist } from "../../../../api/services/userService";
import { debounce } from "lodash";
import "vue-date-pick/dist/vueDatePick.css";
// import DatePick from "vue-date-pick";
export default {
  name: "MyDetail",
  // components : {
  //   DatePick
  // },
  props: {
    editModel: {
      type: Object,
      default: () => {},
    },
    chargeToRoom: {
      type: Boolean,
      default: false,
    },
    forGift: {
      type: Boolean,
      default: false,
    },
    displayEmailField: {
      type: Boolean,
      default: true,
    },
    displayMobileField: {
      type: Boolean,
      default: true,
    },
    disableNameField: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isRegistered: false,
      createNewAccount: false,
      userSearchDebounce: null,
      birthDatestatus: 0,
      birthDate: "",
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "viewConfig",
      "getTotalPrice",
      "getRecentOrder",
      "showNewUi",
      "selectedCompany",
    ]),
    isEmailReadonly() {
      return this.editModel.Email && this.user ? true : false;
    },
    isMobileReadonly() {
      // check if user phone exists from db to prevent disabling field wrongly
      return !!(this.editModel.Phone && this.user && this.user.phone);
    },
    fullName: {
      get() {
        if(!this.editModel.LastName.length) {
          return this.editModel.FirstName;
        }
        return this.editModel.FirstName + " " + this.editModel.LastName;
      },
      set(val) {
        if (!val) return;
        let names = val.split(" ");

        this.editModel.FirstName = names[0];
        this.editModel.LastName = names.slice(1, names.length + 1).join(" ");
      },
    },
    bdstatus() {
      return this.birthDatestatus != 0 ? "invaliddatetime" : "";
    },
  },
  mounted() {
    this.userSearchDebounce = debounce(this.checkEmailExistance, 200);
    this.userSearchDebounce();
    var lastOrder = this.getRecentOrder(this.$route.params.storeid);
    if (lastOrder && !this.user) {
      this.editModel.Phone = lastOrder.ContactCustomer_Contact_Number;
      this.editModel.Email = lastOrder.ContactCustomer_Email_Address;
      this.editModel.FirstName = lastOrder.ContactCustomer_FirstName;
      this.editModel.LastName = lastOrder.ContactCustomer_LastName;
    }
  },
  methods: {
    ...mapMutations(["setShowOverlay"]),
    getMax() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? 10 : 15;
    },
    getRegex() {
      let country = this.selectedCompany.Location.Country;
      return country == "AU" || country == "Australia" ? /04\d{8}/ : /\d/;
    },
    syncFirstName(firstName) {
      if (this.$parent.syncFirstName) this.$parent.syncFirstName(firstName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    onEmailChange() {
      this.userSearchDebounce();
    },
    checkEmailExistance() {
      this.isRegistered = false;
      userIsExist(this.editModel.Email)
        .then((result) => {
          if (result.length > 0) {
            this.$parent.setUserIsExist(true);
            this.isRegistered = true;
          } else {
            this.$parent.setUserIsExist(false);
            this.isRegistered = false;
          }
        })
        .catch(() => {
          this.$parent.setUserIsExist(false);
          this.isRegistered = false;
        });
    },
    check: function (event) {
      this.createNewAccount = event.target.checked;
    },
    setRegisterNewUserState(state) {
      this.createNewAccount = state;
    },
    isValidDate(s) {
      if (s && s != "") {
        let bits = s.split("/");
        let d = new Date(bits[2], bits[1] - 1, bits[0]);
        let valid =
          d.getFullYear() == bits[2] &&
          d.getMonth() + 1 == bits[1] &&
          bits[2].length == 4;
        if (valid) {
          this.birthDatestatus = 0;
          return true;
        } else {
          this.birthDatestatus = 2;
          return false;
        }
      } else {
        this.birthDatestatus = 1;
        return false;
      }
    },
    parseDate(dateString) {
      let date = dateString.split("/");
      if (
        date[0] &&
        date[0].length > 0 &&
        date[1] &&
        date[1].length > 0 &&
        date[2] &&
        date[2].length == 4
      ) {
        return new Date(date[2], date[1] - 1, date[0]);
      } else {
        return undefined;
      }
    },
  },
};
</script>
